<template>
  <SSection :desktop-full="true" :title="t('views.cottage.share.title')">
    <ClientOnly>
      <TShare :networks="getNetworks()" />
    </ClientOnly>
  </SSection>
</template>

<script setup lang="ts">
import type { networksType } from '~/modules/design-system/components/t-share/constants'
import { getNoParamsCurrentUrl } from '~/utils/getNoParamsCurrentUrl'

const getNetworks = (): networksType => {
  const noParamsCurrentUrl = getNoParamsCurrentUrl()
  return [
    {
      kind: 'whatsapp',
      url:
        noParamsCurrentUrl +
        '?utm_medium=share&utm_campaign=ficha_de_casas&utm_source=whatsapp',
      title: t('views.cottage.share.whatsapp.title'),
      message: '',
    },
    {
      kind: 'copy',
      title: t('views.cottage.share.copy.title'),
      url:
        noParamsCurrentUrl +
        '?utm_medium=share&utm_campaign=ficha_de_casas&utm_source=copiar_enlace',
      copiedText: t('views.cottage.share.copy.copiedText'),
    },
  ]
}
</script>
